<template>
    <div class="content-body" v-if="!disabled" v-loading="loading">
        <el-row id="complete_booking_header_wrapper">
            <h1 id="complete_booking_title">
                {{$t('bookingOrder.bookingConfirmTitle')}}
            </h1>
            <h3 id="send_email_noti">{{$t('bookingOrder.sendMailNoti')}}</h3>
            <h3 id="to_my_page_noti">{{$t('bookingOrder.listBookingContent')}}<el-link style="color: #4B86E8;" @click="toMyPage"> マイページ </el-link>{{$t('bookingOrder.checkLinkNoti')}}</h3>
        </el-row>

        <el-row>
            <h3 id="booking_number_title">{{$t('bookingOrder.bookingNumberTitle')}}</h3>
            <h4 id="booking_number">{{bookingNumber}}</h4>
        </el-row>

        <el-row id="add_booking_button_wrapper">
            <el-button id="add_booking_button" @click="addBooking">{{$t('bookingOrder.addBookingButton')}}</el-button>
        </el-row>

        <el-row id="back_to_landing_page_button_wrapper">
            <el-button id="back_to_landing_page_button" @click="backToLandingPage">{{$t('bookingOrder.backButton')}}</el-button>
        </el-row>

    </div>

</template>

<script>
    import Pages from "../../../router/Pages";

    export default {
        name: "CompleteBooking",

        data() {
            return {
                disabled: true,
                bookingNumber: null,
                loading: false
            }
        },

        created() {
          window.addEventListener('pageshow', (event) => {
            if (event.persisted) {
              console.log('This page was restored from the bfcache.');
              window.location.reload();
              this.$emit('redirectToBookingPage');
            } else {
              console.log('This page was loaded normally.');
            }
          });
        },

        methods: {
            addBooking() {
                this.$router.push({path: "/home"});
            },

            backToLandingPage() {
                window.location.href = process.env.VUE_APP_LANDING_PAGE_LINK;
            },

            toMyPage() {
                this.$router.push(Pages.myPage.path);
            },

            show() {
                this.disabled = false;
            },

            hide() {
                this.disabled = true;
            },

            enableLoading() {
                this.loading = true;
            },

            disableLoading() {
                this.loading = false;
            },

            setBookingNumber(bookingNumber) {
                this.bookingNumber = bookingNumber;
            }
        }
    }
</script>

<style scoped lang="scss">
    .content-body {
        margin-left: 22%;
        margin-right: 22%;
    }

    #complete_booking_header_wrapper{
        margin-bottom: 20px;
    }

    #complete_booking_title{
        font-weight: bold;
        font-size: 30px;
        text-align: center;
    }

    #add_booking_button_wrapper{
        margin-right: 20%;
        margin-left: 20%;
        margin-top: 0px
    }

    #add_booking_button{
        width: 100%;
        background-color: #4B86E8;
        color: white
    }

    #back_to_landing_page_button_wrapper{
        margin-right: 20%;
        margin-left: 20%;
        margin-top: 30px;
    }

    #back_to_landing_page_button{
        width: 100%;
    }

    @media only screen and (max-width: 1024px) {
        .content-body {
            margin-left: 15%;
            margin-right: 15%;
        }
    }

    @media only screen and (max-width: 768px) {
        .content-body {
            width: 100%;
            margin-left: 0;
            margin-right: 0;
        }
    }

    @media only screen and (max-width: 450px) {
        .content-body {
            margin-left: 0%;
            margin-right: 0%;
        }

        #complete_booking_header_wrapper{
            margin-bottom: 10px;
        }

        #complete_booking_title{
            font-size: 120%;
        }

        #add_booking_button_wrapper{
            margin-right: 0%;
            margin-left: 0%;
            margin-top: 0px
        }

        #add_booking_button{
            width: 100%;
            background-color: #4B86E8;
            color: white
        }

        #back_to_landing_page_button_wrapper{
            margin-right: 0%;
            margin-left: 0%;
            margin-top: 10px;
        }

        #back_to_landing_page_button{
            width: 100%;
        }

        #send_email_noti{
            font-size: 100%;
        }

        #to_my_page_noti{
            font-size: 100%;
        }

        #booking_number_title{
            margin-top: 0px;
            font-size: 100%;
            margin-bottom: 10px;
        }

        #booking_number{
            font-size: 90%;
            margin-top: 0px;
        }
    }

</style>